/** Display formatting for session recordings (en-AU, device time zone). */

/** `34:12` count-up clock; minutes keep counting past 59 (sessions run to 100 min). */
export function formatRecordingClock(totalSec: number): string {
  const safe = Math.max(0, Math.floor(Number.isFinite(totalSec) ? totalSec : 0))
  const minutes = Math.floor(safe / 60)
  const seconds = safe % 60
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

/** `34 min` / `1 h 05 min` — the once-a-minute screen-reader announcement. */
export function formatRecordingMinutesSpoken(totalSec: number): string {
  const minutes = Math.max(0, Math.floor(totalSec / 60))
  if (minutes === 1) return '1 minute recorded'
  return `${minutes} minutes recorded`
}

/** `34 min 12 s` for durations in the review details. */
export function formatRecordingDuration(totalSec: number | null | undefined): string {
  if (totalSec == null || !Number.isFinite(totalSec)) return '—'
  const safe = Math.max(0, Math.round(totalSec))
  const minutes = Math.floor(safe / 60)
  const seconds = safe % 60
  if (minutes === 0) return `${seconds} s`
  return seconds === 0 ? `${minutes} min` : `${minutes} min ${seconds} s`
}

function toDate(iso: string | number | null | undefined): Date | null {
  if (iso == null) return null
  const ms = typeof iso === 'number' ? iso : Date.parse(iso)
  return Number.isFinite(ms) ? new Date(ms) : null
}

/** `29 Oct`. */
export function formatRecordingDay(iso: string | number | null | undefined): string {
  const date = toDate(iso)
  if (!date) return ''
  return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' })
}

/** `22 Oct 3:41 pm`. */
export function formatRecordingDateTime(iso: string | number | null | undefined): string {
  const date = toDate(iso)
  if (!date) return ''
  const time = date
    .toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' })
    .replace(/\s?([AP])M$/i, (_m, ap: string) => ` ${ap.toLowerCase()}m`)
  return `${formatRecordingDay(date.getTime())} ${time}`
}
